"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.naturalLanguageJoin = void 0;
function naturalLanguageJoin(parts) {
    if (parts.length === 0) {
        return '';
    }
    if (parts.length === 1) {
        return parts[0];
    }
    return `${parts.slice(0, parts.length - 1).join(', ')} and ${parts[parts.length - 1]}`;
}
exports.naturalLanguageJoin = naturalLanguageJoin;
//# sourceMappingURL=naturalLanguageJoin.js.map